import { Controller } from "@hotwired/stimulus";

// Buffer + dot painting for the 4-digit keypad. Submission is the
// consumer's job: listen for "pin-pad:filled", then call wrong() or
// right() with the outcome. Timings are the design pack's motion spec.
export default class extends Controller {
  static targets = ["dots", "dot", "input"];
  static values = { length: { type: Number, default: 4 } };

  connect() {
    this.timers = [];
    this.buffer = "";
    this.busy = false;
    this.dotsTarget.classList.remove("shake");
    this.dotTargets.forEach((dot) => dot.classList.remove("on", "merge"));
  }

  disconnect() {
    this.timers.forEach(clearTimeout);
    this.timers = [];
  }

  press(event) {
    if (this.busy || this.buffer.length >= this.lengthValue) return;
    this.buffer += event.params.key;
    this.paint();
    if (this.buffer.length === this.lengthValue) {
      if (this.hasInputTarget) this.inputTarget.value = this.buffer;
      this.dispatch("filled", { detail: { pin: this.buffer } });
    }
  }

  clear() {
    if (this.busy) return;
    this.buffer = "";
    if (this.hasInputTarget) this.inputTarget.value = "";
    this.paint();
  }

  backspace() {
    if (this.busy) return;
    this.buffer = this.buffer.slice(0, -1);
    if (this.hasInputTarget) this.inputTarget.value = "";
    this.paint();
  }

  // One damped shake, then dots clear left to right with a 50ms stagger.
  wrong() {
    this.busy = true;
    this.dotsTarget.classList.add("shake");
    this.timers.push(setTimeout(() => {
      this.dotsTarget.classList.remove("shake");
      this.dotTargets.forEach((dot, i) =>
        this.timers.push(setTimeout(() => dot.classList.remove("on"), i * 50))
      );
      this.buffer = "";
      if (this.hasInputTarget) this.inputTarget.value = "";
      this.timers.push(setTimeout(() => { this.busy = false; }, 400));
    }, 300));
  }

  // Dots merge to centre and fade; the consumer advances the flow.
  right() {
    this.busy = true;
    this.dotTargets.forEach((dot, i) => {
      dot.style.setProperty("--mx", `${(1.5 - i) * 18}px`);
      dot.classList.add("merge");
    });
  }

  paint() {
    this.dotTargets.forEach((dot, i) =>
      dot.classList.toggle("on", i < this.buffer.length)
    );
  }
}
